function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 20,
  fill: "#00BEA2"
});

var _ref3 = React.createElement("path", {
  d: "M21 16.5V20a1 1 0 0 1-1 1h-2a1 1 0 0 1-1-1v-1.5M7 18.5V20a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1v-3.5",
  stroke: "#fff",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref4 = React.createElement("path", {
  clipRule: "evenodd",
  d: "M3 16.5v-2.755c0-.796.316-1.56.879-2.123L5 10.5h14l1.121 1.121c.563.563.879 1.326.879 2.122V16.5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z",
  stroke: "#fff",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref5 = React.createElement("path", {
  d: "m21 9.5-2 .5M5 10l-2-.5M5 10.5v-.506l.836-3.137A2.501 2.501 0 0 1 8.253 5h7.582a2.5 2.5 0 0 1 2.432 1.92L19 9.994v.506M6 14.5h2M16 14.5h2",
  stroke: "#fff",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgVehicleInCircle = function SvgVehicleInCircle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, React.createElement("svg", _extends({
    x: 8,
    y: 7,
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref3, _ref4, _ref5));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVehicleInCircle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vehicle-in-circle.0433ec5f.svg";
export { ForwardRef as ReactComponent };